import classnames from 'classnames'
import { get } from 'lodash'
import * as React from 'react'

import FormDropdown, { FormStyles } from 'embed/components/FormDropdown'
import { CREDIT_CARD_PURPOSES_LIST } from 'embed/constants'
import { Filter } from 'even-ts-static'
export interface Props {
  containerClass?: string
  onChange?: (fieldName: string, value: string) => void
  styles: FormStyles
  startingValue?: string
}

export const CardPurposesFilter: React.SFC<Props> = ({ containerClass, onChange, startingValue, styles }) => (
  <FormDropdown
    containerClass={containerClass}
    fieldName={Filter.CardPurposes}
    items={CREDIT_CARD_PURPOSES_LIST}
    label="Card Category"
    onChange={onChange}
    startingValue={startingValue}
    styles={styles}
  />
)

CardPurposesFilter.defaultProps = {
  containerClass: '',
  onChange: () => null,
  startingValue: '',
  styles: {
    dropDown: '',
    dropDownLabel: '',
    fieldError: '',
  },
}
